import Banner, { BannerProps } from './Banner';

import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface ErrorBannerProps extends BannerProps {}
export default function ErrorBanner({ className, children }: ErrorBannerProps) {
  const { i18n } = useTranslation();
  return (
    <Banner className={classNames('banner--error', className)}>
      <span>{typeof children === 'boolean' ? i18n.t('common.error.occur') : children}</span>
    </Banner>
  );
}
